import { proforientationRecommendationSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationRecommendationExcurionsYearsSelector = createSelector(
  [proforientationRecommendationSelectors.excursions],
  (proforientationApplicationExcursions) =>
    extractDatesFromNestedItems(
      [proforientationApplicationExcursions],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
